const SELECTRORS = {
  swiperContainer: '.quality-swiper',
};
/**
 * Initialize swiper
 *
 * @param {object} Swiper swiper class object
 * @param {object} Pagination swiper pagination module
 */
const initQualityCardSlider = (Swiper, Pagination) => {
  const swiperContainer = document.querySelector(SELECTRORS.swiperContainer);
  const swiperOptions = {
    modules: [Pagination],
    slidesPerView: 'auto',
    spaceBetween: 16,
    watchOverflow: true,
    loop: false,
    pagination: {
      el: '.shopify-section--about-us-and-quality .swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  };
  if (swiperContainer && Swiper) {
    // eslint-disable-next-line no-unused-vars
    const qualitySwiper = new Swiper(swiperContainer, swiperOptions);
  }
};
document.addEventListener('DOMContentLoaded', () => {
  window.LoadSwiper.then((module) => {
    initQualityCardSlider(module.Swiper, module.Pagination);
  });
});
